import React, { Component } from 'react';
import styled from 'styled-components';
import media from './MediaQueries';
import { translate } from 'react-polyglot';

import filterIcon from '../../images/instore/icons/filter.svg';

const StyledFilterWrapper = styled.div`
  position: absolute;
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
  width: 100%;
  top: 120px;
  z-index: 1;
  ${media.phone`
    flex-direction: column;
    top: 60px;
    justify-content: flex-start;
    z-index: 5;
  `}
  .filterIcon {
    display: none;
    & + label {
      display: none;
      ${media.phone`
        display: inline;
        cursor: pointer;
        position: relative;
        background-image: url(${filterIcon});
        height: 24px; width: 24px;
      `}
    }
    &:checked ~ ul {
      ${media.phone`
        opacity: 1;
        transform: translate3d(0, 0, 0);
      `}
    }
  }
  ul, li {
    list-style: none;
  }
  ul {
    display: flex;
    transition: transform .25s ease-in, opacity .25s ease-in;
    ${media.phone`
      margin-top: 20px;
      opacity: 0;
      transform: translate3d(0, -20px, 0);
    `}
    .routine {
      max-width: calc(120px * 2);
    }
    .category {
      max-width: calc(120px * 3);
    }
    li {
      ${media.phone`
        width: 100%;
        height: 44px;
      `}
    }
  }
`

const StyledLi = styled.li`
  cursor: pointer;
  display: flex; justify-content: center; align-items: center;
  width: 120px;
  height: 44px;
  background-color: ${props => props.active ? 'rgba(30,144,255,0.30)' : 'rgba(0,0,0,0.30)'};
  border: 1px solid rgba(0,0,0,0.12);
  color: white;
  text-align: center;
  font-size: 14px;
  font-weight: ${props => props.active ? 800 : 500};
  text-transform: capitalize;
  &:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`

class FilterButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: props.products,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { products } = this.state;
    if (JSON.stringify(nextProps.products) !== JSON.stringify(products)) {
      this.setState({
        products: nextProps.products,
      })
    }
  }

  isChoiceActive = (choice) => {
    const { filters } = this.props;
    const { inRequestProperty } = this.props.options;
    let found = false;
    if (inRequestProperty) {
      found = filters.hasOwnProperty(inRequestProperty)
        && filters[inRequestProperty].hasOwnProperty(choice)
        && filters[inRequestProperty][choice] > 0;
    } else {
      found = filters[choice] > 0;
    }
    return found;
  }

  componentWillMount() {
    const { toggleFilter, fetchProducts } = this.props;
    const { choices, defaultChoice, inRequestProperty } = this.props.options;
    
    let considerDefaultChoice = true;
    choices.map((choice) => {
      if (this.isChoiceActive(choice, false)) {
        considerDefaultChoice = false;
      }
      return null;
    });
    if (considerDefaultChoice) {
      toggleFilter(defaultChoice, 1, choices, false, false, null, inRequestProperty, true);
    } else {
      fetchProducts();
    }
  }

  render = () => {
    const { setPriceGroup, pricegroup, toggleFilter, regimen, configOptions, t } = this.props;
    const { products } = this.state;
    const { choices, inRequestProperty } = this.props.options;
    return (
      <StyledFilterWrapper>
        <input type="checkbox" className="filterIcon" id="filterIcon"/>
        <label htmlFor="filterIcon"></label>
        <ul className="routine">
          {regimen && choices && choices.map((choice, i) => {
            return (
              <StyledLi 
                key={i}
                active={this.isChoiceActive(choice)}
                onClick={() => {
                  toggleFilter(choice, 1, choices, false, false, null, inRequestProperty, true);
                }}
                >
                {t(choice)}
              </StyledLi>
            )
          })}
        </ul>
        
        {products && configOptions.results.priceGroups &&
          <ul className="category">
            {Object.keys(configOptions.results.priceGroups.default).map((pg, i) => {
              let count = 0;
              if (products.hasOwnProperty(pg)) {
                count = Object.keys(products[pg]).length;
              }
              return <StyledLi 
                key={i} 
                active={(pg === pricegroup)} 
                onClick={() => {
                  setPriceGroup(pg);
                }}
              >
                {pg + ' ('+count+')' }
              </StyledLi>
            })}
          </ul>
        }
      </StyledFilterWrapper>
    )
  }
}

export default translate()(FilterButtons);


// WEBPACK FOOTER //
// ./src/components/instore/ProductFilterButtons.js